import { VisitaEstado } from './visitasStatus';

// Tipos de visita de investigacion de siniestro: AT, EP y PRAM.
export const INVESTIGACION_VISIT_TYPE_IDS = [467, 469, 474];

export const esVisitaDeInvestigacion = (visita: any): boolean =>
    Array.isArray(visita?.actividades) &&
    visita.actividades.some((actividad: any) =>
        INVESTIGACION_VISIT_TYPE_IDS.includes(actividad?.tipoVisita?.id)
    );

// Informe de investigacion desde la visita (SMP-401): perfiles habilitados (Preventor y Admin BO),
// en una visita de investigacion con siniestro y aprobada por el BO. Son las mismas condiciones que
// valida el backend (permiso de registro de visita, investigacion y PRESENTADO).
export const puedeDescargarPdfInvestigacion = (visita: any, perfilHabilitado?: boolean): boolean =>
    Boolean(perfilHabilitado) &&
    esVisitaDeInvestigacion(visita) &&
    Boolean(visita?.siniestro?.id) &&
    visita?.estado === VisitaEstado.PRESENTADO;
